// extracted by mini-css-extract-plugin
module.exports = {"commentsLink":"C5kb","orange":"C5pb","white":"C5pd","commentsIcon":"C5pf"};